import React from "react";
import "./BarData.css"
import {IoTodayOutline} from "react-icons/io5"
import {AiOutlineCalendar} from "react-icons/ai";
import {CgProfile} from "react-icons/cg";


function BarData({ menu }) {
  return (
      
      <div className="nav" >
      <div >{menu.name=="home"? <IoTodayOutline size="22"/>:
      (menu.name=="calendar"? <AiOutlineCalendar size="22"/>:
      <CgProfile size="22"/>) }</div>
      <p className="pstyle"> {menu.name} </p>
      </div>
      
    
  );
}

export default BarData;